var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "jade-toast", attrs: { role: "alert" } }, [
    _c(
      "div",
      { staticClass: "jade-toast__content" },
      [
        _vm._t("leading"),
        _c(
          "jade-text",
          {
            attrs: {
              variant: "text-large",
              weight: "regular",
              color: "on-color",
              "data-testid": "main-text",
            },
          },
          [_vm._v(" " + _vm._s(_vm.text) + " ")]
        ),
      ],
      2
    ),
    _vm.actionName
      ? _c(
          "div",
          { staticClass: "jade-toast__trailing", attrs: { role: "button" } },
          [
            _c(
              "div",
              {
                staticClass: "jade-toast__action",
                attrs: {
                  tabindex: "0",
                  role: "button",
                  "data-testid": "button-action",
                },
                on: {
                  click: _vm.handleClickAction,
                  keyup: [
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.handleKeyDown.apply(null, arguments)
                    },
                    function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "space", 32, $event.key, [
                          " ",
                          "Spacebar",
                        ])
                      )
                        return null
                      return _vm.handleKeyDown.apply(null, arguments)
                    },
                  ],
                },
              },
              [
                _c(
                  "jade-text",
                  { attrs: { variant: "hyperlink-medium", color: "on-color" } },
                  [_vm._v(" " + _vm._s(_vm.actionName) + " ")]
                ),
              ],
              1
            ),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }